class SelectLink {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
    }

    onInit () {
        // this._elem.addEventListener('change', () => { this.onSubmit() })
    }

    onSubmit () {
        // window.location.href = this._elem.value
    }
}

export default SelectLink



// WEBPACK FOOTER //
// ./src/resources/scripts/components/SelectLink.js